import Navbar from "../../components/navbar/Navbar";
import Apps from "../../components/apps/Apps";
import "./Apps.css";

function AppsPage() {
  return (
    <div className="apps-page">
      <Navbar />
      <Apps />
    </div>
  );
}

export default AppsPage;
